import React from 'react'
import PropTypes from 'prop-types'
import { useViewport, viewportBreakpoint } from '../../utils'
import { GalleryPopup, GalleryItem } from '.'

const imagesData = [
  '/images/articles/khub_artikel_1.jpg',
  '/images/articles/khub_artikel_2.jpg',
  '/images/articles/khub_artikel_3.jpg',
  '/images/articles/khub_artikel_4.jpg',
  '/images/articles/khub_artikel_1.jpg',
  '/images/articles/khub_artikel_2.jpg',
  '/images/articles/khub_artikel_3.jpg',
  '/images/articles/khub_artikel_4.jpg',
]

const GallerySection = ({ images }) => {
  const [initialSlide, setInitialSlide] = React.useState(0)
  const [show, setShow] = React.useState(false)
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  const height = isMobile ? '66px' : '100px'

  const handlePopup = (index) => {
    setInitialSlide(index)
    setShow(true)
  }

  return (
    <div>
      <h2 className="text-lg lg:text-2xl mb-8 uppercase font-bold">Gallery</h2>
      <div className="flex flex-wrap -mx-1 lg:-mx-4">
        {
          images.map((image, index) => index < 7 ? (
            <div className="w-1/3 lg:w-1/4 px-1 lg:px-4 mb-2 lg:mb-8" key={index}>
              <GalleryItem height={height} onClick={() => handlePopup(index)} src={image}/>
            </div>
          ) : (
            <div className="w-1/3 lg:w-1/4 px-1 lg:px-4 mb-2 lg:mb-8" key={index}>
              <div className="relative" onClick={() => handlePopup(index)}>
                <div className="rounded cursor-pointer absolute w-full h-full flex items-center justify-center" style={{background: 'rgba(0, 0, 0, 0.75)'}}>
                  <p className="text-white underline text-sm">+5 More</p>
                </div>
                <GalleryItem height={height} src={image}/>
              </div>
            </div>
          ))
        }
      </div>
      {
        show &&
        <GalleryPopup onClose={setShow} isMobile={isMobile} images={images} initialSlide={initialSlide}/>
      }
    </div>
  )
}

GallerySection.propTypes = {
  images: PropTypes.array
}

GallerySection.defaultProps = {
  images: imagesData
}

export { GallerySection }
